import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';
import { OrderValuePipe } from '../order-value/order-value.pipe';

@Pipe({
  name: 'orderProvision',
  standalone: true,
})
export class OrderProvisionPipe implements PipeTransform {
  public transform(order: OrderData, valueType: 'open' | 'filled', quoteToUse?: number | undefined): number | undefined {
    if (this.#invalidProvisionOrder(order, valueType)) {
      return undefined;
    }

    if (valueType === 'filled') {
      return (order.provisionFzEur ?? 0) + (order.provisionBankEur ?? 0);
    }

    let orderValue = new OrderValuePipe().transform(order, valueType, quoteToUse);
    if (!orderValue) {
      return undefined;
    }
    //orderValue can be negative provision should not
    orderValue = Math.abs(orderValue);

    const provisionTotalPct = (order.provisionFzPct ?? 0) + (order.provisionBankPct ?? 0);
    const orderProvision = (orderValue * provisionTotalPct) / 100;
    return Number.isNaN(orderProvision) ? undefined : orderProvision;
  }

  #invalidProvisionOrder(order: OrderData, provisionType: 'open' | 'filled'): boolean {
    return (
      !order ||
      (provisionType === 'filled' && !order.provisionFzEur && !order.provisionBankEur) ||
      (provisionType === 'open' && !order.provisionFzPct && !order.provisionBankPct)
    );
  }
}
